import apiClient from './client';

// NOTE: baseURL override mirrors the skillsLibrary/tenders workaround until the
// apiClient embeds the version in the path.
const V2_BASE = '/api/v2';

export type PersonaStatus = 'ACTIVE' | 'DEPRECATED';

export interface LibraryPersonaAlias {
  id: string;
  text: string;
  status: PersonaStatus;
}

export interface LibraryPersona {
  id: string;
  name: string;
  status: PersonaStatus;
  /** Distinct tenders demanding this archetype (analogue of a skill's "assigned"). */
  demand: number;
  aliases: LibraryPersonaAlias[];
}

export interface LibraryPersonaGroup {
  letter: string;
  count: number;
  personas: LibraryPersona[];
}

export interface PersonaLibrary {
  groups: LibraryPersonaGroup[];
}

/** The full grouped persona catalog. */
export async function fetchPersonaLibrary(): Promise<PersonaLibrary> {
  const response = await apiClient.get<PersonaLibrary>('/personas/library', { baseURL: V2_BASE });
  return response.data;
}
